import { Helmet } from 'react-helmet-async';
import { Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import CEODashboard from './CEODashboard';
import OperatorDashboard from './OperatorDashboard';
import AdminDashboard from './AdminDashboard';
import CustomerDashboard from './CustomerDashboard';

export default function DashboardAppPage() {
  const { user } = useSelector((state) => state.auth);

  const renderContent = (role) => {
    switch (role) {
      case 'CEO':
        return <CEODashboard />;
      case 'OPERATOR':
        return <OperatorDashboard />;
      case 'ADMINISTRATOR':
        return <AdminDashboard />;
      default:
        return <CustomerDashboard />;
    }
  };

  return (
    <>
      <Helmet>
        <title> JMC </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          {t('common.greeting', { name: `${user?.firstName} ${user?.lastName}` })}
        </Typography>
        {renderContent(user?.role)}
      </Container>
    </>
  );
}
